// extracted by mini-css-extract-plugin
export default {"sideBar-icon":"SideBar_sideBar-icon__XLQZ8","sideBar-icon-tour":"SideBar_sideBar-icon-tour__7c3mH"};